import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router";
import Loader from "../../Loader/Loader";
import { editcategory } from "../../services/Mainservice";
import { Snackbar } from "../../utils/snackbar";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.name) {
    errors.name = "Required";
  }
  return errors;
};

const EditCategory = () => {
  const [load, setload] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const items = location.state.item;
  console.log(location);
  const handleClose = (event, reason) => {
    setOpen(false);
  };

  useEffect(() => {
    formik.setValues(
      {
        name: items.Name,
      },
      false
    );
    formik.validateForm();
  }, [items]);

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validate: (values) => validate(values, isInitialLoad),
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await editcategory(items.id, values.name);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Edit Category</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Category Name</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.name}
              className="Auth_input"
            />
            {formik.errors.name ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>

          <div />

          <button className="term_button" type="Submit">
            Save
          </button>
        </form>
      </div>
      {load && <Loader />}
      <Snackbar
        open={open}
        severity="error"
        onclose={handleClose}
        message={err}
      />
      <Snackbar
        open={open2}
        severity="success"
        onclose={handleClose}
        message={success}
      />
    </>
  );
};
export default EditCategory;
